import CogIcon from '@heroicons/react/outline/esm/CogIcon.js'

import { useI18n } from '@tribeplatform/react-components/i18n'
import { useRouter } from '@tribeplatform/react-sdk'
import { SystemSpaceSlug, useSpaceUtil } from '@tribeplatform/react-sdk/hooks'
import { IconButton } from '@tribeplatform/react-ui-kit/Button'

export const NotificationSettingsLink = props => {
  const { Link } = useRouter()
  const { generatePath } = useSpaceUtil()
  const { $t } = useI18n()

  return (
    <IconButton
      as={Link}
      href={`${generatePath(SystemSpaceSlug.PROFILE_SETTINGS)}/notifications`}
      icon={<CogIcon />}
      variant="tertiaryNeutral"
      size="lg"
      accessibilityLabel={$t({
        defaultMessage: 'Notification settings',
        id: 'Generics.NotificationSetting',
      })}
      {...props}
    />
  )
}
